
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Switch from '@/components/switch.vue';
import Message from '@/components/message.vue';
import {
	handleClipboard
} from '@/utils/clipboard'
import {
	providerproviderErpConfig,
	providerproviderErpConfigSave
} from '@/api/supplier';
@Component({
	name: '',
	components: {
		PageFooter,
		'slz-switch': Switch,
		'slz-message': Message,
	}
})

export default class ProductList extends Vue {
	private pageloading = false
	private form: any = {
		ProviderId: this.$route.query.Id,
		IsUserERP: false,
		ErpType: 0,
		App_key: '',
		App_secret: '',
		RefreshToken: '',
		tianxie: false,
		Shop_id: '',

		WangDianTongAppId: '', //旺店通AppId
		WangDianTongAppKey: '', //旺店通AppKey
		WangDianTongAppSecret: '', //旺店通AppSecret
		WangDianTongApiUrl: '', //旺店通ApiUrl
		WangDianTongShopNo: '', //旺店通ShopNo

	}
	private saveshow = true
	private returnShow = false
	private link = 'https://provider.routuan.com/erp/callback/jushuitan?ProviderId=' + this.$route.query.Id

	private mounted() {
		this.getform()
	}


	private copyaftersales(event) {
		handleClipboard(this.link, event)
	}
	private async getform() {
		try {
			this.pageloading = true
			let res = await providerproviderErpConfig({
				ProviderId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				for (let key in this.form) {
					this.form[key] = res.Result[key]
				}
				this.form.Shop_id = this.form.Shop_id || ''
				this.saveshow = !res.Result.IsUserERP
				this.form.tianxie = res.Result.App_key ? true : false
			}
		} finally {
			this.pageloading = false
		}
	}
	private async save() {
		if (this.form.ErpType === 0) {
			if (!this.form.App_key) {
				this.$message.error('请输入App_key')
				return
			} else if (!this.form.App_secret) {
				this.$message.error('请输入App_secret')
				return
			} else if (!this.form.RefreshToken) {
				this.$message.error('请输入RefreshToken')
				return
			} else if (!this.form.tianxie) {
				this.$message.error('请在erp后台填写物流回传链接，若已设置请勾选已填写')
				return
			} else if (!this.form.Shop_id) {
				this.$message.error('请输入店铺编号')
				return
			}
		}else if (this.form.ErpType === 1){
			if (!this.form.WangDianTongApiUrl) {
				this.$message.error('请输入ErpApiUrl')
				return
			} else if (!this.form.WangDianTongAppId) {
				this.$message.error('请输入ErpAppId')
				return
			} else if (!this.form.WangDianTongAppKey) {
				this.$message.error('请输入ErpAppKey')
				return
			} else if (!this.form.WangDianTongAppSecret) {
				this.$message.error('请输入ErpAppsecret')
				return
			} else if (!this.form.WangDianTongShopNo) {
				this.$message.error('请输入店铺编号')
				return
			}
		}


		try {
			this.pageloading = true
			let res = await providerproviderErpConfigSave({
				...this.form,
				ProviderId: Number(this.$route.query.Id)
			})
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.pageloading = false
		}
	}
}
